import { createFileRoute } from '@tanstack/react-router';
import TimesheetsLayout from 'containers/Timesheets/TimesheetsLayout';

export const Route = createFileRoute('/_authenticated/timesheets')({
  component: TimesheetsLayout,
});
